/**
 * ⚠️ INTERIM BRIDGE — remove once backend ships a bearer→cookie exchange endpoint.
 *
 * The mobile app (which keeps `Authorization: Bearer` permanently) opens the PWA's KYC
 * flow and hands its session over in the URL: `/kyc-verification?token=<jwt>`.
 *
 * Before the cookie migration the PWA just stored that JWT as its own session. It can't
 * any more: only the backend can mint an httpOnly cookie, so a token arriving in the URL
 * cannot be turned into a session client-side.
 *
 * Until backend provides an exchange (bearer in → `Set-Cookie` out), we keep that one
 * handoff on bearer. It is deliberately scoped: the token lives in sessionStorage (dies
 * with the tab, never persisted), and is only attached when a handoff actually happened.
 * Every other request in the app authenticates by cookie alone.
 */
const HANDOFF_TOKEN_KEY = "deex_kyc_handoff_token";

export const setHandoffToken = (token: string) => {
  try {
    sessionStorage.setItem(HANDOFF_TOKEN_KEY, token);
  } catch {
    // Private mode / storage disabled — the handoff simply won't work.
  }
};

export const getHandoffToken = (): string | null => {
  try {
    return sessionStorage.getItem(HANDOFF_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const clearHandoffToken = () => {
  try {
    sessionStorage.removeItem(HANDOFF_TOKEN_KEY);
  } catch {
    // nothing to clear
  }
};

/** Authorization header for the handoff, or `{}` when authenticating by cookie. */
export const handoffAuthHeader = (): Record<string, string> => {
  const token = getHandoffToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
